import { Card, Col } from 'reactstrap'
import { ColoredHeadings } from '../../../../utils/Constant'
import { headingData } from '../../../../Data/Ui-Kits/Typography/Typography'
import ColorHeadingBody from './ColorHeadingBody'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const ColorHeading = () => {
  return (
    <Col xxl="6">
      <Card className="height-equal">
        <CommonCardHeader title={ColoredHeadings} span={headingData} tagClass="mb-0" />
        <ColorHeadingBody />
      </Card>
    </Col>
  )
}

export default ColorHeading